
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18.11 1.76999L19.07 0.809992C19.1625 0.717288 19.2724 0.643741 19.3934 0.593559C19.5143 0.543378 19.644 0.517548 19.775 0.517548C19.906 0.517548 20.0357 0.543378 20.1566 0.593559C20.2776 0.643741 20.3875 0.717288 20.48 0.809992L21.19 1.51999C21.58 1.90999 21.58 2.53999 21.19 2.92999L20.23 3.88999L18.11 1.76999ZM17.11 2.76999L19.23 4.88999L13.26 10.86C13.1671 10.9533 13.0417 11.0071 12.91 11.01H11.5C11.22 11.01 11 10.79 11 10.51V9.09999C11 8.96999 11.05 8.83999 11.15 8.74999L17.11 2.76999ZM15.13 2.63999L9.79 7.97999C9.61 8.16999 9.5 8.41999 9.5 8.68999V11.52C9.5 12.07 9.95 12.52 10.5 12.52H13.33C13.6 12.52 13.85 12.41 14.04 12.23L19.37 6.89999C19.77 7.87999 20 8.98999 20 10.21C20 13.39 17.55 17.13 12.66 21.44C12.28 21.77 11.71 21.77 11.33 21.44C6.45 17.13 4 13.39 4 10.21C4 5.22999 7.8 2.00999 12 2.00999C13.09 2.00999 14.16 2.22999 15.13 2.63999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-edit-location`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconEditLocation

    ```js
    <b-new-b-icon-edit-location />
    ```
</docs>


